// extracted by mini-css-extract-plugin
export default {"root":"hIr9BAZV","primary":"mS0liFyw","secondary":"jN0Dts1K","stretched":"EHdqDlbb"};